export const RANK_STATUS = { UPDATED: -2, CREATED_LASTED: -1, CREATED_EARLIEST: 1, OPEN: -9, COLLECT: -3 }
export const QUERY_TYPE = { ALL: 3, MY: 1, COOP: 2 }
